
import Vue from 'vue';
// import AffiliateAndPromotions from '@/views/Promotions/AffiliateAndPromotions';
import { mapActions, mapState } from 'vuex';
// import TeamPlanChoices from '@/views/Team/TeamPlanSignup';
import { functions, db } from '@/firebase';
// import ConfirmDialog from '@/components/base/ConfirmDialog.vue';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { downloadCsvFromArray } from '@/utils';
import moment from 'moment-timezone';
import _omit from 'lodash/omit';
import _keys from 'lodash/keys';
// import TeamAppMetricsReport from '@/views/Reports/TeamReports.vue';

export default Vue.extend({
	name: 'Prototyping',
	metaInfo: {
		title: 'Prototyping | RunDiffusion',
	},
	data () {
		return {
			cwResourcesDataStr: '',
			loadingCanceledStorageVolumesData: false,
		};
	},
	computed: {
		...mapState([
			'user',
		]),
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		async getCanceledStorageVolumesData () {
			this.loadingCanceledStorageVolumesData = true;
			try {
				const functionRef = functions
					.httpsCallable('getCanceledStorageVolumesData');
				const result = (await functionRef({
					lastId: null,
					cwResourcesDataStr: this.cwResourcesDataStr,
				})).data;
				console.log(result);
				if (result && result.errorMessage) {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.ERROR,
						message: result.errorMessage,
						show: true,
					});
				}
			} catch (e) {
				console.error(e);
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'Error running getCanceledStorageVolumesData',
					show: true,
				});
			} finally {
				this.loadingCanceledStorageVolumesData = false;
			}
		},
	},
	components: {
		// TeamAppMetricsReport,
		// ConfirmDialog,
		// TeamPlanChoices,
		// PrototypeEmailAssets,
		// AffiliateAndPromotions,
	},
});
